import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err, "Link non valido o scaduto. Richiedi un nuovo link."));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-[#E8DFD5] bg-[#FBF8F3] px-4 py-3.5 text-sm text-[#2C2723] outline-none transition-all duration-300 placeholder:text-[#8C7B6E]/60 focus:border-[#B85328] focus:ring-2 focus:ring-[#B85328]/15";

  return (
    <main className="mx-auto flex max-w-md flex-col px-4 py-16 sm:py-24">
      <div className="text-center">
        <p className="eyebrow justify-center">Recupero password</p>
        <h1 data-testid="reset-heading" className="font-display mt-3 text-3xl font-semibold text-[#2C2723] sm:text-4xl">
          Scegli una <span className="italic text-[#B85328]">nuova password</span>
        </h1>
      </div>

      <div className="mt-8 rounded-3xl border border-[#E8DFD5] bg-white p-7 shadow-sm sm:p-9">
        {done && (
          <div data-testid="reset-success" className="text-center">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#EAF0ED] text-[#4A6B5D]">
              <CheckCircle2 size={24} />
            </span>
            <p className="font-display mt-5 text-2xl font-semibold text-[#2C2723]">Password aggiornata!</p>
            <p className="mt-3 text-sm text-[#5C534B]">Ora puoi accedere con la nuova password.</p>
            <Link
              to="/accedi"
              data-testid="reset-go-to-login"
              className="mt-6 inline-block rounded-full bg-[#B85328] px-7 py-3 text-sm font-semibold text-[#FBF8F3] transition-all hover:bg-[#9C421C]"
            >
              Vai all'accesso
            </Link>
          </div>
        )}
        {!done && !token && (
          <p data-testid="reset-missing-token" className="text-center text-sm text-[#B85328]">
            Link non valido.{" "}
            <Link to="/recupera" className="font-semibold underline underline-offset-4">
              Richiedi un nuovo link
            </Link>
          </p>
        )}
        {!done && token && (
          <form data-testid="reset-form" onSubmit={submit} className="space-y-4">
            <input
              data-testid="reset-input-password"
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nuova password (minimo 8 caratteri)"
              className={inputCls}
            />
            <input
              data-testid="reset-input-confirm"
              type="password"
              required
              minLength={8}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Ripeti la nuova password"
              className={inputCls}
            />
            {error && (
              <p data-testid="reset-error-message" className="rounded-xl bg-[#B85328]/10 px-4 py-3 text-xs font-medium text-[#B85328]">
                {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="reset-submit-button"
              disabled={busy}
              className="w-full rounded-full bg-[#B85328] py-4 text-sm font-semibold text-[#FBF8F3] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#9C421C] hover:shadow-xl disabled:opacity-60"
            >
              {busy ? "Un attimo..." : "Salva la nuova password"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
};

export default ResetPassword;
